"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncReverse = asyncReverse;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _asyncToArray = require("../$to-array/async-to-array");

async function* asyncReverse(source) {
  let array = source;
  array = await (0, _asyncToArray.asyncToArray)(array);

  for (let i = array.length - 1; i >= 0; i--) {
    yield array[i];
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncReverse);

exports.default = _default;